export default function LoadingSpinner() {
  return (
    <div className='full-screen-loader'>
      <div
        id='loading-spinner'
        className='loading-spinner absolute-center'
      ></div>
    </div>
  );
}
